import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const SalesManagerTargetForm = (
  strings: any,
  users: any[],
  periods: any[],
  autoCalculateAchievedTargets: boolean = false,
): FormModel[] => {
  return [
    {
      label: 'Details',
      value: '',
      type: 'section',
      field: 'details-section',
      placeholder: '',
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },
    {
      label: 'User',
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: 'Select User',
      field: 'user',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: true,
      options: users,
    },
    {
      label: 'Period',
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: 'Select Period',
      field: 'period',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: true,
      options: periods,
    },
    {
      label: 'Targets',
      value: '',
      type: 'section',
      field: 'targets-section',
      placeholder: '',
      validators: [],
      responsive: { xs: 12 },
      required: false,
    },
    {
      label: 'Auto calculate achieved targets',
      value: false,
      type: 'checkbox',
      field: 'autoCalculateAchievedTargets',
      placeholder: '',
      validators: [],
      responsive: { xs: 12 },
      required: false,
      sx: { mt: -1 },
    },
    {
      label: 'Room Night Target',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: 'Enter Room Night Target',
      field: 'roomNightTarget',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: false,
    },
    {
      label: 'Room Night Achieved',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: 'Enter Room Night Achieved',
      field: 'roomNightAchieved',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: false,
      disabled: autoCalculateAchievedTargets,
    },
    {
      label: 'Room Revenue Target',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: 'Enter Room Revenue Target',
      field: 'roomRevenueTarget',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: false,
    },
    {
      label: 'Room Revenue Achieved',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: 'Enter Room Revenue Achieved',
      field: 'roomRevenueAchieved',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: false,
      disabled: autoCalculateAchievedTargets,
    },
    {
      label: 'Event Count Target',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: 'Enter Event Count Target',
      field: 'miceCountTarget',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: false,
    },
    {
      label: 'Event Count Achieved',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: 'Enter Event Count Achieved',
      field: 'miceCountAchieved',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: false,
      disabled: autoCalculateAchievedTargets,
    },
    {
      label: 'Event Revenue Target',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: 'Enter Event Revenue Target',
      field: 'miceRevenueTarget',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: false,
    },
    {
      label: 'Event Revenue Achieved',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: 'Enter Event Revenue Achieved',
      field: 'miceRevenueAchieved',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 6 },
      required: false,
      disabled: autoCalculateAchievedTargets,
    },
  ];
};
